/**
 * Generated by orval v6.23.0 🍺
 * Do not edit manually.
 * APIs for RCI FE
 * This document describes the APIs provided by NeoAP BE for RCI FE, designed to be integrated into NeoAP FE using `iframe`.\
These APIs utilize cookie-based authentication. All API requests must include the cookie `_ap_session`.

 * OpenAPI spec version: 1
 */
import { faker } from '@faker-js/faker';
import { ArrayFrom } from '@moneyforward/ap-frontend-components';
import { HttpResponse, delay, http } from 'msw';

export const getGetAiAgentSettingMock = () => ({
  ai_agent_service_settings: ArrayFrom(
    { length: faker.number.int({ min: 1, max: 10 }) },
    (_, i) => i + 1
  ).map(() => ({
    is_enabled: true,
    service_type: faker.helpers.arrayElement([
      'invoice_download_agent',
      'payment_request_ocr_support_agent',
    ] as const),
  })),
  is_ai_agent_enabled: true,
});

export const getUpdateAiAgentServiceSettingsMock = () => ({
  results: [
    {
      service_type: 'invoice_download_agent',
      is_enabled: true,
      status: 'error',
      message: 'Updated the AI agent usage settings',
    },
  ],
});

export const handlers = [
  http.get('*/api/js/ai_agent_setting', async () => {
    await delay(1000);
    return new HttpResponse(JSON.stringify(getGetAiAgentSettingMock()), {
      status: 200,
      headers: {
        'Content-Type': 'application/json',
      },
    });
  }),
  http.patch('*/api/js/ai_agent_setting', async () => {
    await delay(1000);
    return new HttpResponse(null, {
      status: 200,
      headers: {
        'Content-Type': 'application/json',
      },
    });
  }),
  http.put('*/api/js/ai_agent_service_settings', async () => {
    await delay(1000);
    return new HttpResponse(
      JSON.stringify(getUpdateAiAgentServiceSettingsMock()),
      {
        status: 200,
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
  }),
];
